import app from 'flarum/forum/app';
import Modal, {IInternalModalAttrs} from 'flarum/common/components/Modal';
import User from 'flarum/common/models/User';
import AuditBrowser from '../../common/components/AuditBrowser';

interface UserAuditModalAttrs extends IInternalModalAttrs {
    user: User
}

export default class UserAuditModal extends Modal<UserAuditModalAttrs> {
    className() {
        return 'AuditModal UserAuditModal';
    }

    title() {
        return app.translator.trans('kilowhat-audit.forum.modal.user-title');
    }

    content() {
        return AuditBrowser.component({
            baseQ: 'user:' + this.attrs.user.username(),
        });
    }
}
